module.exports = __webpack_public_path__ + "img/29_47.36fcd025.png";